// components/RadioButton/RadioButton.js

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const RadioButton = ({ selected, onClick }) => {
  return (
    <RadioButtonContainer onClick={onClick} aria-checked={selected} role="radio">
      <OuterCircle selected={selected}>
        {selected && <InnerCircle />}
      </OuterCircle>
    </RadioButtonContainer>
  );
};

RadioButton.propTypes = {
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default RadioButton;

// Styled Components
const RadioButtonContainer = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
`;

const OuterCircle = styled.div`
  align-items: center;
  border: 2px solid ${({ theme, selected }) => (selected ? theme.colors.brandMain : theme.border.defaultWeak)};
  border-radius: 50%;
  display: flex;
  height: 20px;
  justify-content: center;
  transition: border 0.3s ease;
  width: 20px;

  &:hover {
    border-color: ${({ theme }) => theme.colors.brandMain};
  }
`;

const InnerCircle = styled.div`
  background-color: ${({ theme }) => theme.colors.brandMain};
  border-radius: 50%;
  height: 10px;
  width: 10px;
`;
